// extracted by mini-css-extract-plugin
export default {"content":"NewReport_content__sqoAs"};